import styled from 'styled-components';
import { Columns } from '../base/grid';

export const Wrapper = styled.div``;

export const FieldWrapper = styled(Columns)`
	margin-bottom: 3rem;
`;
